var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jwchat-count",style:(_vm.style)},[(_vm.getTitle)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.getTitle))]):_vm._e(),_c('div',{staticClass:"number",style:(_vm.numberStyle)},[_vm._v(_vm._s(_vm.count))]),(_vm.getUnit)?_c('div',{style:(_vm.unitStyle)},[_vm._v(_vm._s(_vm.getUnit))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }